export default __webpack_public_path__ + "static/media/f13.f7d2e558.jpg";